export interface MdmPipelineModel {
    name: string;
    cron: string;
    timezone: string;
    nextExecutionDate: string;
    lastExecutionDate: string;
    lastJobState: string;
}

export interface GetMdmPipelinesResponse {
    mdmPipelines: MdmPipelineModel[];
}

export enum DataTypeEnum {
    Companies = 1,
    ClassificationSocieties = 36,
    Flags = 47
}

export interface ClearEtlProcessExecutionWarningResponse {
    updated: any;
}

export interface FailedEtlProcessExecutionResponse {
    updated: any;
}